import { render, staticRenderFns } from "./message-details-to-block.vue?vue&type=template&id=7252bf1e&scoped=true&"
import script from "./message-details-to-block.vue?vue&type=script&lang=js&"
export * from "./message-details-to-block.vue?vue&type=script&lang=js&"
import style0 from "./message-details-to-block.vue?vue&type=style&index=0&id=7252bf1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7252bf1e",
  null
  
)

export default component.exports